import React from 'react';

import { Select } from 'components/ui/select';

import type { MarketOption } from './types';

interface Props {
  inputId?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  markets: MarketOption[];
  value: string | null;
  onChange: (code: string | null) => void;
}

// Census markets only, no free text: a page fills the slot by its market's code.
export default function MarketPicker({ inputId, isDisabled, isLoading, markets, value, onChange }: Props) {
  const selected = markets.find(market => market.code === value) ?? null;

  return (
    <Select<MarketOption>
      getOptionLabel={(market: MarketOption) => market.title}
      getOptionValue={(market: MarketOption) => market.code}
      inputId={inputId}
      isClearable
      isDisabled={isDisabled}
      isLoading={isLoading}
      noOptionsMessage="No Census market matches"
      options={markets}
      placeholder="Choose a Census market"
      value={selected}
      onChange={(market: MarketOption | null) => onChange(market?.code ?? null)}
    />
  );
}
